import React, { Component } from 'react';
import AuthHelperMethods from './components/auth/AuthHelperMethods';
import withAuth from './components/auth/withAuth';
import { withRouterV6 } from './withRouterV6';
import CopApp from './components/cop/CopApp';

class CopWrapper extends Component {
	Auth = new AuthHelperMethods();

	constructor(props) {
		super(props);
		this.state = {
			user: null,
		};
	}

	componentDidMount() {
		// Theme (dark default, light via the user menu) is owned by CopApp,
		// which syncs the app-wide cookie and document id.

		const confirm = this.props.confirm;
		if (confirm) {
			this.setState({
				user: {
					email: confirm.email || '',
					name: confirm.name || confirm.email || 'User',
					role: confirm.role || 'user',
					picture: confirm.picture || null,
				},
			});
		}
	}

	render() {
		return <CopApp user={this.state.user} />;
	}
}

export default withRouterV6(withAuth(CopWrapper));
